import { render, staticRenderFns } from "./report_child.vue?vue&type=template&id=bf1f787e&scoped=true"
import script from "./report_child.vue?vue&type=script&lang=js"
export * from "./report_child.vue?vue&type=script&lang=js"
import style0 from "./report_child.vue?vue&type=style&index=0&id=bf1f787e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1f787e",
  null
  
)

export default component.exports